// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--abbf1";
export var square = "Checkbox-module--square--151f9";
export var content = "Checkbox-module--content--f8dcf";
export var input = "Checkbox-module--input--20727";